export default __webpack_public_path__ + "static/alfred_restart-262452cdef1fac62f2a36e2da83995a6.png";